<template>
  <div class="main">
    <div class="col-12 mb-4">
      <ul class="nav nav-tabs" id="dados-tab" role="tablist">
        <li class="nav-item" role="presentation">
          <a
            class="nav-link active"
            id="profile-tab"
            data-toggle="tab"
            href
            role="tab"
            aria-controls="profile"
            aria-selected="false"
            @click="activeData = 1"
            >Usuários</a
          >
        </li>
        <li class="nav-item" role="presentation">
          <a
            class="nav-link"
            id="home-tab"
            data-toggle="tab"
            href
            role="tab"
            aria-controls="home"
            aria-selected="true"
            @click="activeData = 0"
            >Cursos</a
          >
        </li>
      </ul>
    </div>
    <div class="col-12" v-show="activeData == 0">
      <div class="row">
        <div class="col-md-12 mt-md-1 mt-4">
          <p class="font-weight-bold text-dark d-flex align-items-center">
            <i class="material-icons text-success pr-2">list</i> Licenças
          </p>
          <p class="small pt-2">
            Gerencie suas licenças e acompanhe a evolução dos usuários nos
            cursos.
          </p>
          <hr />
          <loading v-if="loading" />
          <div v-else>
            <DataTable
              class="p-datatable-striped p-datatable-responsive-demo"
              selectionMode="single"
              :value="cursos"
              data-key="id"
              @row-select="listUsuariosCurso"
            >
              <template #empty>
                Você ainda não adquiriu nenhum curso.
              </template>
              <template #loading> Carregando... </template>
              <Column field="curso" header="Nome do Curso"></Column>
              <Column field="adquiridas" header="Adquiridas" sortable>
                <template #body="slotProps">
                  <span class="badge badge-success">
                    {{ slotProps.data.adquiridas }}</span
                  >
                </template>
              </Column>
              <Column field="disponiveis" header="Disponíveis" sortable>
                <template #body="slotProps">
                  <span class="badge badge-warning">
                    {{ slotProps.data.disponiveis }}</span
                  >
                </template>
              </Column>
              <Column
                field="utilizadas"
                center
                header="Utilizadas"
                sortable
                headerStyle="text-align: center"
              >
                <template #body="slotProps">
                  <span class="badge badge-danger">
                    {{ slotProps.data.utilizadas }}</span
                  >
                </template>
              </Column>
              <Column field="courseid" header="">
                <template #body="">
                  <span class="badge badge-primary"> Visualizar </span>
                </template>
              </Column>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12" v-show="activeData == 1">
      <div class="row">
        <div class="col-md-12 mt-md-1 mt-4">
          <p class="font-weight-bold text-dark d-flex align-items-center">
            <i class="material-icons text-success pr-2">person</i> Usuários
            cadastrados
          </p>
          <p class="small pt-2">
            Utilize este recurso para cadastrar novos usuários e vinculá-los aos
            cursos desejados. Clique em "Adicionar usuário" para começar.
          </p>
          <hr />
          <button
            type="button"
            class="btn btn-verde fit-content d-flex justify-content-end align-items-end ml-auto mb-3"
            :disabled="loading"
            data-toggle="modal"
            data-target="#modaladdusuario"
          >
            <span>+ Adicionar usuário</span>
          </button>
          <loading v-if="loading" />
          <div v-else>
            <DataTable
              class="p-datatable-striped p-datatable-responsive-demo"
              selectionMode="single"
              :value="usuarios"
              data-key="id"
            >
              <Column field="firstname" header="Nome"></Column>
              <Column field="lastname" header="Sobrenome"></Column>
              <Column
                field="username"
                header="Usuário / E-mail"
                sortable
              ></Column>
              <Column field="id" header="">
                <template #body="slotProps">
                  <button
                    class="btn btn-primary"
                    data-toggle="modal"
                    data-target="#modaladdusuarioacurso"
                    @click="usuarioCurso = slotProps.data.id"
                  >
                    + Vincular a um curso
                  </button>
                </template>
              </Column>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
    <Dialog
      :closeOnEscape="true"
      :header="singleCursoLista.curso + ' - Usuários'"
      :visible.sync="displayModal"
      :style="{ width: '90vw' }"
      :modal="true"
    >
      <loading v-if="loading" />
      <div v-else>
        <div v-if="singleCurso[0].usuarios.length">
          <DataTable
            class="p-datatable-striped"
            selectionMode="single"
            :value="singleCurso[0].usuarios"
            data-key="id"
          >
            <template #empty> Você ainda não adquiriu nenhum curso. </template>
            <template #loading> Carregando... </template>

            <Column field="firstname" header="Nome"></Column>
            <Column field="lastname" header="Sobrenome"></Column>
            <Column field="email" header="E-mail"></Column>

            <Column field="lastcourseaccess" header="Atividade do curso">
              <template #body="slotProps">
                <span
                  class="badge badge-success"
                  v-if="parseInt(slotProps.data.lastcourseaccess) > 0"
                  >Iniciado</span
                >
                <span
                  class="badge badge-warning"
                  v-if="parseInt(slotProps.data.lastcourseaccess) == 0"
                  >Não iniciado</span
                >
              </template>
            </Column>
            <Column field="coursecompleted" header="Concluído">
              <template #body="slotProps">
                <span
                  class="badge badge-success"
                  v-if="parseInt(slotProps.data.coursecompleted) > 0"
                  >Sim</span
                >
                <span class="badge badge-danger" v-else>Não</span>
              </template>
            </Column>
            <Column field="userid" header="">
              <template #body="slotProps">
                <button
                  v-if="parseInt(slotProps.data.lastcourseaccess) == 0"
                  class="btn btn-danger"
                  @click="
                    removerUsuario(slotProps.data.userid, slotProps.data.email)
                  "
                >
                  Remover
                </button>
              </template>
            </Column>
          </DataTable>
        </div>
        <hr />
      </div>
      <template #footer>
        <button type="button" class="btn fit-content" @click="closeModal">
          <span>Fechar</span>
        </button>
      </template>
    </Dialog>
    <!-- Modal -->
    <div
      class="modal fade"
      id="modaladdusuario"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5
              class="modal-title d-flex justify-content-center align-itens-center"
              id="exampleModalLongTitle"
            >
              <i class="material-icons secondary">list</i> ADICIONAR USUÁRIO
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              id="closemodal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form
            class="form_padrao pt-2"
            id="form_user"
            ref="form_user"
            action
            @submit.prevent="addUsuario"
          >
            <div class="modal-body">
              <div class="form-row">
                <div class="form-group flutuante col-md-12">
                  <input
                    type="text"
                    name="nome"
                    id="primeironome"
                    v-model="usuario.firstname"
                    required
                  />
                  <label for="primeronome">Nome</label>
                </div>
                <div class="form-group flutuante col-md-12">
                  <input
                    type="text"
                    name="sobrenome"
                    id="sobrenome"
                    v-model="usuario.lastname"
                    required
                  />
                  <label for="sobrenome">Sobrenome</label>
                </div>
                <div class="form-group flutuante col-md-12">
                  <input
                    type="text"
                    name="email"
                    id="emailusuario"
                    v-model="usuario.email"
                    required
                  />
                  <label for="email">E-mail</label>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="submit"
                class="btn btn-verde fit-content"
                :disabled="loading"
              >
                <span
                  class="spinner-grow spinner-grow-sm pr-2"
                  role="status"
                  aria-hidden="true"
                  v-show="loading"
                  @click="addAoCurso"
                ></span>
                <span v-if="loading">Salvando aguarde...</span>
                <span v-else>Salvar</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Modal adicionar usuario ao curso -->
    <div
      class="modal fade"
      id="modaladdusuarioacurso"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5
              class="modal-title d-flex justify-content-center align-itens-center"
              id="exampleModalLongTitle"
            >
              <i class="material-icons secondary">list</i> VINCULAR USUÁRIO A UM
              CURSO
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              id="closemodalusuario"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form class="form_padrao pt-2">
            <div class="modal-body">
              <div class="form-row">
                <div class="form-group flutuante col-md-12">
                  <select
                    name="email"
                    id="selectcurso"
                    v-model="cursoSelecionado"
                    required
                  >
                    <option
                      :value="curso.courseid"
                      v-for="curso in cursos"
                      :key="curso.courseid"
                    >
                      {{ curso.curso }}
                    </option>
                  </select>
                  <label for="email" v-if="!cursoSelecionado"
                    >Selecione um curso</label
                  >
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-verde fit-content"
                :disabled="loading"
                @click="addAoCurso"
              >
                <span
                  class="spinner-grow spinner-grow-sm pr-2"
                  role="status"
                  aria-hidden="true"
                  v-show="loading"
                ></span>
                <span v-if="loading">Salvando aguarde...</span>
                <span v-else>Salvar</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formata } from "../../helpers";
// import TabMenu from "primevue/tabmenu";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Dialog from "primevue/dialog";
export default {
  name: "Meuscursos",
  components: { DataTable, Column, Dialog },
  data() {
    return {
      usuarioCurso: 0,
      cursoSelecionado: 0,
      carregando: false,
      displayModal: false,
      singleCurso: [
        {
          usuarios: [{}],
        },
      ],
      singleCursoLista: "",
      usuario: {
        firstname: "",
        lastname: "",
        email: "",
      },
      items: [
        { label: "Home", icon: "pi pi-fw pi-home", to: "/tabmenu" },
        {
          label: "Calendar",
          icon: "pi pi-fw pi-calendar",
          to: "/tabmenu/calendar",
        },
        { label: "Edit", icon: "pi pi-fw pi-pencil", to: "/tabmenu/edit" },
        {
          label: "Documentation",
          icon: "pi pi-fw pi-file",
          to: "/tabmenu/documentation",
        },
        { label: "Settings", icon: "pi pi-fw pi-cog", to: "/tabmenu/settings" },
      ],
      activeData: 1,
      cursos: [],
      usuarios: [],
      loading: false,
      valorPacote: formata(this.$user.pacoteSocio.valorlimiteinf),
    };
  },
  methods: {
    removerUsuario(userid, email) {
      this.loading = true;
      this.$http
        .post("/api/Ead/RemoverUsuarioCursoEAD", {
          userid: userid,
          courseid: this.singleCursoLista.courseid,
          email: email,
        })
        .then((response) => {
          this.loading = false;
          this.closeModal();
          this.getMeusCursos();
          this.$toast.open({
            message: response.data.mensagem,
            type: "success",
          });
        })
        .catch(() => {
          this.closeModal();
          this.loading = false;
          this.$toast.open({
            message:
              "Falha ao remover o usuário ao curso. Por favor tente novamente",
            type: "warning",
          });
        });
    },
    openModal() {
      this.displayModal = true;
    },
    closeModal() {
      this.displayModal = false;
    },
    addAoCurso() {
      this.loading = true;
      this.$http
        .post("/api/Ead/IncluirUsuarioCursoEAD", {
          userid: this.usuarioCurso,
          courseid: this.cursoSelecionado,
        })
        .then((response) => {
          this.loading = false;
          let modal = document.querySelector("#closemodalusuario");
          modal.click();
          this.getMeusCursos();
          this.$toast.open({
            message: response.data.mensagem,
            type: "success",
          });
        })
        .catch(() => {
          this.loading = false;
          this.$toast.open({
            message:
              "Falha ao adicionar o usuário ao curso. Por favor tente novamente",
            type: "warning",
          });
        });
    },
    addUsuario() {
      this.loading = true;
      this.$http
        .post("/api/Ead/IncluirUsuarioAssociadoEAD", this.usuario)
        .then((response) => {
          if (response.data.erro) {
            this.$toast.open({
              message: response.data.mensagem,
              type: "warning",
            });
            this.loading = false;
            let modal = document.querySelector("#closemodal");
            modal.click();
            this.usuario = [];
          } else {
            this.loading = false;
            let modal = document.querySelector("#closemodal");
            modal.click();
            this.$toast.open({
              message: response.data.mensagem,
              type: "success",
            });
            this.usuario = [];
            this.getUsuariosCursos();
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$toast.open({
            message: error,
            type: "warning",
          });
        });
    },
    onRowSelect(event) {
      console.log(event.data);
    },
    listUsuariosCurso(event) {
      if (event.data.utilizadas == 0) {
        this.$toast.open({
          message: "Você ainda não adicionou nenhum usuário neste curso",
          type: "warning",
        });
      } else {
        this.displayModal = true;
        this.loading = true;
        this.singleCurso = [
          {
            usuarios: [{}],
          },
        ];
        this.singleCursoLista = event.data;
        this.$http
          .get("/api/Ead/ListarUsuariosPorCursoAssociadoEAD")
          .then((response) => {
            this.loading = false;
            var resp = response.data;
            this.singleCurso = resp.filter(
              (e) => e.courseid == event.data.courseid
            );
            if (typeof this.singleCurso[0].usuarios === "undefined") {
              this.singleCurso[0].usuarios = [];
            }
          })
          .catch((error) => {
            this.loading = false;
            this.singleCurso = [];
            console.error(error);
          });
      }
    },
    getMeusCursos() {
      this.loading = true;
      this.$http
        .get("/api/Ead/ListarLicencasAssociadoEAD")
        .then((response) => {
          this.loading = false;
          this.cursos = response.data;
        })
        .catch((error) => {
          this.loading = false;
          console.error(error);
        });
    },
    getUsuariosCursos() {
      this.loading = true;
      this.usuarios = [];
      this.$http
        .get("/api/Ead/ListarUsuariosPorAssociadoEAD")
        .then((response) => {
          if (response.data.erro) {
            this.$toast.open({
              message: response.data.mensagem,
              type: "warning",
            });
            this.loading = false;
          } else {
            this.loading = false;
            this.usuarios = response.data;
          }
        })
        .catch((error) => {
          this.loading = false;
          console.error(error);
        });
    },
  },
  async created() {
    this.getMeusCursos();
    this.getUsuariosCursos();
  },
};
</script>
<style lang="scss" scoped>
.badge-primary {
  color: #fff;
  background-color: #05438e;
  height: 40px;
  width: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
  border-radius: 0;
}
.modal-body {
  input {
    background: #f4f2f7 !important;
  }
}
.nav-item {
  a {
    transition: all 0.2s ease-in-out;
    color: #888;
    padding: 0.7rem;
    margin: 0 0.3rem;
    font-size: 0.9rem;
    font-weight: 600;
  }
}
.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  color: #ffffff;
  background-color: #05438e;
  border-color: none;
  padding: 0.7rem;
}
.nav-tabs .nav-link:focus,
.nav-tabs .nav-link:hover {
  border-color: transparent;
}
.form_padrao {
  .form-group.flutuante {
    position: relative;
    input[type="text"],
    input[type="password"],
    input[type="email"],
    input[type="tel"],
    textarea {
      background: white;
    }
  }
  .fit-content {
    max-width: fit-content;
    padding: 0.6rem 1rem !important;
  }
}
@media screen and(max-width: 900px) {
  .fit-content {
    max-width: 100% !important;
  }
}

.card_content {
  min-height: 170px;
  display: flex;
  justify-content: space-between;
  small {
    line-height: 1.5rem;
  }
  .badge {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 6px 10px;
    cursor: pointer;
    border-radius: 0px;
    background: #05428e;
    i {
      font-size: 13px;
      color: #fecc0d;
    }
  }
  &:hover {
    transform: scale(1.05);
  }
}
.btn-primary {
  color: #fff;
  background-color: #04448e;
  border-color: #04448e;
  border-radius: 0;
}
</style>

<style lang="scss">
.p-datatable-responsive-demo .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}
// @media screen and (min-width: 901px) {
// .flutuante{
//   margin-left: -15px
// }
// }
@media screen and (max-width: 40em) {
  .p-datatable-responsive-demo {
    .p-datatable-thead > tr > th,
    .p-datatable-tfoot > tr > td {
      display: none !important;
    }

    .p-datatable-tbody > tr > td {
      text-align: left;
      display: block;
      width: 100%;
      float: left;
      clear: left;
      border: 0 none;

      .p-column-title {
        padding: 0.4rem;
        min-width: 30%;
        display: inline-block;
        margin: -0.4em 1em -0.4em -0.4rem;
        font-weight: bold;
      }

      &:last-child {
        border-bottom: 1px solid var(--surface-d);
      }
    }
  }
}
</style>
